import React from 'react';
import { Building2Icon, CalculatorIcon, CheckIcon, ReceiptTextIcon, ShieldCheckIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { useLanguage } from '../../contexts/LanguageContext';
const icons = {
  building: Building2Icon,
  shield: ShieldCheckIcon,
  calculator: CalculatorIcon,
  receipt: ReceiptTextIcon
};
export function Services() {
  const {
    t
  } = useLanguage();
  return <section id="services" className="bg-white py-24 sm:py-32" aria-labelledby="services-heading" data-id="element-247" data-mp="nbcfc5hilfau">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-248" data-mp="s8up1y3cvyjw">
        <Reveal data-id="element-249" data-mp="sbh047pggw6v">
          <div className="mx-auto max-w-[760px] text-center" data-id="element-250" data-mp="wbhejsck17dx">
            <p className="text-[12px] font-semibold uppercase tracking-[0.2em] text-brand" data-id="element-251" data-mp="w94wzgapkz1e">
              {t.services.eyebrow}
            </p>
            <h2 id="services-heading" className="headline mt-5 text-[32px] font-bold text-ink sm:text-[46px]" data-id="element-252" data-mp="2y345jtwg52ae">
              {t.services.heading}
            </h2>
            <p className="mt-6 text-[17px] leading-relaxed text-ink/60" data-id="element-253" data-mp="333rzanc27x8b">{t.services.subtitle}</p>
          </div>
        </Reveal>

        <ul className="mt-16 grid gap-6 md:grid-cols-2" data-id="element-254" data-mp="1k0jsa2mfdjcv">
          {t.services.groups.map((service, i) => {
          const Icon = icons[service.icon];
          return <Reveal as="li" key={service.title} delay={i * 0.08} data-id="element-255" data-mp="1fyye8dy5mz13" data-mpi={i}>
                <article className="group relative h-full overflow-hidden rounded-4xl border border-ink/[0.07] bg-white p-8 shadow-soft transition-all duration-300 hover:-translate-y-1.5 hover:border-ink/15 hover:shadow-lift sm:p-10" data-id="element-256" data-mp="1b0oia14lvuef">
                  <span className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-brand/[0.06] opacity-0 transition-opacity duration-500 group-hover:opacity-100" aria-hidden="true" data-id="element-257" data-mp="23m6dae4zpbuo" />
                  <div className="relative" data-id="element-258" data-mp="1tsh5tg0woner">
                    <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-ink transition-colors duration-300 group-hover:bg-brand" data-id="element-259" data-mp="nb2fl3p0yx1o">
                      <Icon className="h-[22px] w-[22px] text-white" aria-hidden="true" data-id="element-260" data-mp="idamw7gk36wf" />
                    </span>
                    <h3 className="mt-7 text-[23px] font-semibold tracking-tight text-ink" data-id="element-261" data-mp="oqy3kdgcgln7">
                      {service.title}
                    </h3>
                    <p className="mt-3 text-[15px] leading-relaxed text-ink/60" data-id="element-262" data-mp="ar5hivfritlk">{service.description}</p>
                    <ul className="mt-7 space-y-3 border-t border-ink/[0.07] pt-7" data-id="element-263" data-mp="fooxq0w0tgg5">
                      {service.items.map(item => <li key={item} className="flex items-center gap-3" data-id="element-264" data-mp="zspo3tys3fj">
                          <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand/10" data-id="element-265" data-mp="5tx0wza9ixmf">
                            <CheckIcon className="h-3 w-3 text-brand" aria-hidden="true" data-id="element-266" data-mp="3o4ibw92vqfu1" />
                          </span>
                          <span className="text-[15px] font-medium text-ink/80" data-id="element-267" data-mp="3e8fcvc3bqxbb">{item}</span>
                        </li>)}
                    </ul>
                  </div>
                </article>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}